<template>
    <div>

        <multiselect v-if="!disabled"
            class="select-members" 
            :options="availableMembers" 
            :multiple="false"
            :placeholder="$t('select_member')"
            :selectLabel="$t('select_member_select')"
            @select="addUser"
        ></multiselect>
        

        <div class="notification limit-message secondary-font" v-if="shareMessage" v-html="$t('cannot_share_project')" ></div>

        <div>
            <div v-for="member in localSharedWith" :key="member._id">
                <div class="level mb-2 member pt-2" >
                    <div class="level-left">
                        <div v-if="member.profile" class="level-item">
                            <figure class="image is-24x24 is-pulled-right" style="margin-right: 5px">
                                <!--<img :src="member.profile.avatar" referrerPolicy="no-referrer" class="is-rounded" />-->
                                <img :src="getImage(member.profile)" referrerPolicy="no-referrer" class="is-rounded" />
                            </figure>
                            <span>
                                <p class="has-text-black has-text-left primary-font">
                                    {{
                                        member.profile.username ||
                                        member.profile.email
                                    }}
                                </p>
                                <p class="has-text-grey has-text-left">
                                    {{ member.profile.email }}
                                </p>
                            </span>
                        </div>

                        <div v-else class="level-item">
                            <span>
                                <p class="has-text-black has-text-left">
                                    {{ member.email }}
                                </p>
                                <p v-t="'projectParticipants.new_user'" class="has-text-black has-text-left"></p>
                            </span>
                        </div>
                    </div>
                    <div class="level-right" v-if="!disabled">
                        <div class="select pt-1" >
                            <select v-model="member.permission" class="member-permissions">
                                <option v-for="permission in permissionOptions" :key="permission" :value="permission">
                                    {{
                                        $t(
                                            `projectConfiguration.access_${permission}`
                                        )
                                    }}
                                </option>
                            </select>
                        </div>

                        <!--<div class="dropdown is-hoverable is-right">
                            <div class="dropdown-trigger">
                                <button class="button is-flat pl-0 pt-2">
                                    <span class="icon is-small dropdown-trigger has-text-grey mx-1">
                                        <i class="mdi mdi-36px mdi-dots-vertical has-text-eduloc-grey-dark"
                                            aria-hidden="true" />
                                    </span>
                                </button>
                            </div>
                            <div id="dropdown-menu" class="dropdown-menu" role="menu">
                                <div class="dropdown-content">
                                    <a v-t="'projectParticipants.remove_permissions'
                                        " class="dropdown-item" @click="removeMember(member)">
                                    </a>
                                    <a v-if="member.profile" v-t="'projectParticipants.resend_invitation'
                                        " class="dropdown-item" @click="$emit('resendInvitation', member)">
                                    </a>
                                </div>
                            </div>
                        </div>-->
                        <div class="is-right">
                            <button class="button is-flat pl-1 pt-2"  @click="removeMember(member)">
                                    <span class="icon is-small dropdown-trigger has-text-grey mx-1">
                                        <i class="mdi mdi-28px mdi-trash-can-outline has-text-eduloc-red-dark"
                                            aria-hidden="true" />
                                    </span>
                                </button>
                        </div>
                    </div>

                    <div class="level-right mr-5" v-else>
                        <div class="select pt-1" >
                            <select disabled v-model="member.permission" class="member-permissions">
                                <option v-for="permission in permissionOptions" :key="permission" :value="permission">
                                    {{
                                        $t(
                                            `projectConfiguration.access_${permission}`
                                        )
                                    }}
                                </option>
                            </select>
                        </div>

                        
                    </div>

                </div>
                <p v-t="`projectConfiguration.access_${member.permission}_description`
                    " class="is-size-7 has-text-eduloc-red secondary-font pb-1 member-description" ></p>
                <hr />
            </div>
        </div>
    </div>
</template>

<script>
import { getUserDataForProjectInvite,fetchEntityMembers } from '@/services/API';
import { PERMISSION_OPTIONS } from '@/lib/constants';
import { validators } from '@/lib/helpers';
import _ from 'underscore';
export default {
    props: {
        defaultPermission: {
            type: String,
            default: 'read',
        },
        sharedWith: {
            type: Array,
            default: () => {
                return [];
            },
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            username: undefined,
            permissionOptions: PERMISSION_OPTIONS,
            localSharedWith: _.clone(this.sharedWith),
            shareMessage: false,
            entityMembers: [],
        };
    },
    computed: {
        searchUsers() {
            /* addProjectMember({
                profile,
                permission: defaultPermission,
              })*/

            return _.debounce(this._searchUsers, 400);
        },
        emailIsValid() {
            return validators.email.test(this.username); // !this.errors.has("email");
        },
        hasSchool() {
            return this.$store.getters.hasSchool;
        },
        sharedIds() {
            let shareds = [];
            this.localSharedWith.forEach((shared) => { 
                shareds.push(shared.profile.owner)
            })
            return shareds;
        },
        availableMembers() {
            // console.log(this.localSharedWith)

            let members=[];
            this.entityMembers.forEach((member) => {
                console.log(this.$store.getters.project.owner.owner,this.$store.getters.user.owner)
                if (!this.sharedIds.includes(member.owner)&&this.$store.getters.project.owner.owner!=member.owner && member.owner!=this.$store.getters.user.owner) {
                    members.push(member.email)
                }
                
            });
            return members;
        }
    },
    watch: {
        localSharedWith: {
            handler() {
                this.$emit('update:sharedWith', this.localSharedWith);
            },
            deep: true,
        },
    },
    methods: {
        addUser(email) {
            console.log(event)
            this.searchUsers({permission: this.defaultPermission,email: email,});
        },
        addEmail(user) {
            if (!this.emailIsValid) {
                return;
            }
            /*if (
                _.find(this.localSharedWith, (sharedUser) => {
                    return sharedUser.email == user.email;
                })
            ) {
                return (this.username = null);
            }*/
            this.searchUsers(user);
            this.username = null;
        },
        addProjectMember(user) {
            if (
                _.find(this.localSharedWith, (sharedUser) => {
                    return sharedUser.profile._id == user.profile._id;
                })
            ) {
                return (this.username = null);
            }

            this.localSharedWith.push(user);
            this.showDropdown = false;
            this.username = null;
        },
        removeMember(member) {
            this.localSharedWith = _.without(this.localSharedWith, member);
        },
        async _searchUsers(user) {
            /*const users = await fetchItems('profile', {
                _q: user.email,
                _limit: 10,*/
            const users = await getUserDataForProjectInvite({
                email: user.email,
                project: this.$store.getters.project._id,
            }).catch((e) => {

                console.error('error fetching profiles',e);
            });
            if (users) {
                // console.log(users.data.length, users.data, this.localSharedWith)
                let listed = false;
                if (1 === users.data.length) {
                    for (let i = 0; i < this.localSharedWith.length; i++) {
                        if (this.localSharedWith[i].profile && this.localSharedWith[i].profile._id == users.data[0]._id) {
                            //console.log("user found")
                            listed = true;
                            return
                        }
                        if (this.localSharedWith[i].email && this.localSharedWith[i].email == user.email) {
                            //console.log("user found")
                            listed = true;
                            return
                        }
                    }
                    if (!listed) {
                        this.localSharedWith.push({
                            profile: users.data[0],
                            permission: user.permission,
                        });
                        return users.data[0];
                    }

                } else if (0 === users.data.length) {
                    // console.log("checking new user")
                    listed = false;
                    for (let i = 0; i < this.localSharedWith.length; i++) {
                        //console.log(this.localSharedWith[i].profile.email,user.email)
                        if (this.localSharedWith[i].email && this.localSharedWith[i].email == user.email) {
                            // console.log("user found")
                            listed = true;
                            return
                        }
                    }
                    if (!listed) {
                        this.localSharedWith.push(user);
                        return user;
                    }
                }
                
            }
        },
        getImage(data) {
            if (data.avatar.length > 0) {
                return data.avatar;
            } else {
                return "/img/usuari.png";
            }
        },
        async fetchUsers() {
            this.users = [];
            if (this.$store.getters.school) {
                let response = await fetchEntityMembers();
                this.entityMembers = response.data;
                // console.log(response.data)
            }
        },
        
    },
    mounted() { 
        this.fetchUsers()
    }
};
</script>

<style scoped>
.dropdown-menu {
    width: 100% !important;
}

.member {
    margin-right: -20px;
}

.member-permissions {
    border-radius: 0;
    padding-top: 0;
    padding-bottom: 0;
    height: 2.3rem;
    background-color: var(--eduloc-grey-background);
    border: 1px solid black;
}

.member-permissions:hover {
    border: 1px solid black;
}

.select:not(.is-multiple):not(.is-loading)::after {
    top: 19px;
}

.to-invite .icon{
    color:var(--eduloc-grey);
}
.to-invite.disabled input{
    background-color:#FFFFFF;
}
.to-invite.disabled input::placeholder{
    color:var(--eduloc-grey);
}

.member.disabled, .member-description.disabled{
    opacity: 0.5;
}

.limit-message{
    position: relative;
    background-color: #000000;
    color: #FFFFFF;
    text-align: left;
    opacity: 0.8;
}

.select-members /deep/ .multiselect__option--highlight, .select-members /deep/ .multiselect__option--highlight::after{
    background: var(--eduloc-red);
}

.select-members /deep/ .multiselect__input{
    font-size: 1rem;
    font-family: 'inter_regular';
}
.select-members /deep/ .multiselect__option{
    font-size: 1rem;
}

</style>
